import { useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';
import { Place } from '@mui/icons-material';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardMedia,
	List,
	ListItem,
	ListItemText,
	Typography
} from '@mui/material';
import { OBJECTS_TYPES } from '../../../constants';
import { BuildingType } from '../../../types';

export const BuildingCard = ({ data }: { data: BuildingType }) => {
	const translate = useTranslate();
	const { name, id, address, location_data } = data;

	return (
		<Card sx={{ maxWidth: 210, display: 'flex', flexDirection: 'column' }}>
			<CardMedia
				component="img"
				height="140"
				image="https://media.istockphoto.com/id/1460762245/photo/modern-style-hi-rise-blue-glass-building-exterior-with-transparent-wall-3d-render.jpg?s=612x612&w=0&k=20&c=a5V0dIHugs_dfzKDHP4NP6WR3lc00vA0wDpaMBrai3o="
				alt="building_image"
			/>
			<CardContent
				sx={{
					padding: 1
				}}
			>
				<Typography noWrap variant="h6" component="div">
					{name}
				</Typography>
				<List>
					<ListItem
						component="a"
						target="_blank"
						href={location_data?.locationUrl}
						disablePadding={true}
					>
						<Place />
						<ListItemText
							slotProps={{
								primary: {
									fontSize: 16,
									fontWeight: 'medium'
								}
							}}
							sx={{ marginLeft: 1 }}
							primary={address}
						/>
					</ListItem>
				</List>
			</CardContent>
			<CardActions
				sx={{
					marginTop: 'auto'
				}}
			>
				<Button
					component={Link}
					to={`/objects/${OBJECTS_TYPES.BUILDINGS}/show/${id}`}
					size="small"
				>
					{translate('list.details')}
				</Button>
			</CardActions>
		</Card>
	);
};
